module.exports = __webpack_public_path__ + "fonts/Clash-Light.a1ffd1a.otf";